import { render, staticRenderFns } from "./emergencyEvent.vue?vue&type=template&id=d149441a&scoped=true"
import script from "./emergencyEvent.vue?vue&type=script&lang=js"
export * from "./emergencyEvent.vue?vue&type=script&lang=js"
import style0 from "./emergencyEvent.vue?vue&type=style&index=0&id=d149441a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d149441a",
  null
  
)

export default component.exports